import { statusName } from './helper';
import { Skeleton } from '../../../../lib/skeleton';
import Switch from '../../../../lib/switch';
import { WorkingSwitchProps } from './types';
import { useBoard } from '../../../../pages/CaseBoard/useBoard';

const WorkingSwitch: React.FC<WorkingSwitchProps> = ({
    working,
    setWorking,
    setShowOptions,
    userStatus,
    loadingStatus,
    setLoadingStatus,
    isLoading,
    currentStatus,
    setCurrentStatus,
    endActivityStatus
}) => {
    const { setIsAnsweringCalls, setIsReadOnly } = useBoard();

    if (currentStatus === statusName.intake) return null;

    const handleWorking = async () => {
        if (!working) {
            setWorking(true);
            setShowOptions(true);
        } else {
            setIsAnsweringCalls(false);

            if (userStatus && userStatus.length < 1) {
                setWorking(false);
                setShowOptions(false);
                return;
            }

            setLoadingStatus(true);
            if (currentStatus !== '') {
                await endActivityStatus.mutateAsync(currentStatus).then(() => setCurrentStatus(''));
            }
            await endActivityStatus.mutateAsync(statusName.working).then(() => {
                setWorking(false);
                setIsReadOnly(true);
            });
            setLoadingStatus(false);
            setShowOptions(false);
        }
    };

    return (
        <div className="flex w-full justify-between items-center p-4">
            {!isLoading && !endActivityStatus.isLoading && !loadingStatus ? (
                <>
                    <label htmlFor="working-state">{working ? 'Working' : 'Not working'}</label>
                    <Switch checked={working} onCheckedChange={handleWorking} id="working-state" />
                </>
            ) : (
                <>
                    <Skeleton className="w-28 h-4 mr-2" />
                    <Skeleton className="w-10 h-4" />
                </>
            )}
        </div>
    );
};
export default WorkingSwitch;
